// TYPESCRIPT MAIN FILE

import "./components/Header";
import "./components/Modules";
import "./components/Footer";

document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]').forEach((link) => {
  link.addEventListener("click", (e) => {
    const target = document.querySelector(link.getAttribute("href")!);
    if (!target) return;
    e.preventDefault();
    const offset = 100; // px — adjust for sticky header height
    const top = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: "smooth" });
  });
});
